import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';
import { illuminateColors, zIndex } from '../../utilities/sharedStyles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            actionAreaButtonsSticky: {
                position: 'sticky',
                bottom: 0,
                height: 0,
                width: '100%',
                zIndex: zIndex.helpButton,
            },
            actionAreaButtonsContainer: {
                position: 'sticky',
                right: theme.spacing(2),
                width: '40px',
                transform: 'translateY(-100%)',
                display: 'flex',
                marginLeft: 'auto',
                flexDirection: 'column',
                alignItems: 'flex-end',
            },
            actionAreaButtonsContainerHorizontal: {
                position: 'sticky',
                right: `calc((100vw - 95%) / 2)`,
                width: '96px',
                transform: 'translateY(10%)',
                display: 'flex',
                marginLeft: 'auto',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: theme.spacing(),
            },
            floatingButton: {
                width: '40px',
                height: '40px',
                borderRadius: '20px',
                border: `2px solid ${theme.palette.common.white}`,
                backgroundColor: theme.palette.background.b9,
                color: theme.palette.common.white,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textDecoration: 'none',
                outline: 'none',
                marginBottom: theme.spacing(1),
                '&:focus': {
                    border: `1px solid ${theme.palette.focus.main}`,
                    boxShadow: `0px 0px 0px 1px ${theme.palette.focus.light}`,
                },
                '&:hover': {
                    color: illuminateColors.brandGreen,
                },
            },
            floatingButtonVertical: {
                '&:last-child': {
                    marginBottom: theme.spacing(2),
                },
            },
            floatingButtonHorizontal: {
                marginRight: '8px',
                marginLeft: '8px',
            },
        }),
    {
        name: 'action-area-buttons-',
    },
);
